var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import { Trans } from 'react-i18next';
import { MdField as MaterialField, MdSelect as MaterialAutocomplete, TimePicker } from '@bytebrand/fe-ui-core-autobahn/compat';
import { FormCheckbox } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import classnames from 'classnames';
import SvgClosedLockIcon from '../../../ui/SVG/ClosedLockIcon';
import form from '../formConfigs/RegistrationFormConfig';
import { default as contactPageForm } from '../../../pages/ContactPage/ContactPageFormConfig';
import { PRIVACY_POLICY_URL, DATA_PROCESSING_URL, TERMS_AND_USE_URL } from '../../../../framework/constants/app';
import { inject, observer } from 'mobx-react';
import styles from './../modals.styl';
import withGoogleOptimize from 'components/hoc/WithGoogleOptimize/WithGoogleOptimize';
import i18next from 'i18next';
const t = (key, options) => i18next.t(key, options);
import { PHONE_PREFIXES } from 'framework/constants/forms';
let RegistrationForm = class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "onHandleTimestampChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (timestamp) => {
                this.setState({ timestamp });
                form.$('timestamp').onChange(timestamp, form.$('timestamp').name);
            }
        });
        Object.defineProperty(this, "onSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onError, onSuccess } = this.props;
                this.setState({
                    isLoading: true
                });
                form.submit()
                    .then((form) => {
                    this.setState({
                        isLoading: false
                    });
                    if (form.hasError) {
                        onError();
                    }
                    else {
                        onSuccess();
                    }
                })
                    .catch((error) => {
                    this.setState({
                        isLoading: false
                    });
                    onError(error);
                });
            }
        });
        Object.defineProperty(this, "redirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onError, onRedirect } = this.props;
                this.setState({
                    isLoading: true
                });
                form.submit()
                    .then((form) => {
                    this.setState({
                        isLoading: false
                    });
                    if (form.hasError) {
                        onError();
                    }
                    else {
                        onRedirect();
                    }
                })
                    .catch((error) => {
                    this.setState({
                        isLoading: false
                    });
                    onError(error);
                });
            }
        });
        Object.defineProperty(this, "onCloseClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { onClose } = this.props;
                event.preventDefault();
                onClose();
            }
        });
        Object.defineProperty(this, "renderAgreement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (React.createElement(Trans, { i18nKey: 'modals:offerRequest.agreementPlaceholder' },
                React.createElement("a", { href: DATA_PROCESSING_URL, target: '_blank', className: styles.termsLink }, "hier"),
                React.createElement("a", { href: PRIVACY_POLICY_URL, target: '_blank', className: styles.termsLink }, "Datenschutzbestimmungen")))
        });
        Object.defineProperty(this, "onBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e, field) => {
                e.preventDefault();
                field.validate().then((subField) => {
                    if (!field.isValid) {
                        subField.showErrors(true);
                    }
                });
            }
        });
        Object.defineProperty(this, "onFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e, field) => {
                e.preventDefault();
                field.validate();
            }
        });
        this.state = {
            isLoading: false,
            timestamp: 0
        };
    }
    changeValue(index) {
        if (typeof (index) === 'number') {
            const value = index;
            const label = t(`CheckoutPage:contactInformation:${form.$('gender').extra[index].label}`);
            return {
                value,
                label
            };
        }
    }
    render() {
        const { t, isSale, lang, hasGoogleOptimize } = this.props;
        const { isLoading } = this.state;
        const day = contactPageForm.$('day').value;
        const time = contactPageForm.$('time').value;
        // Native <input placeholder> only ever renders in one font-weight (::placeholder styles
        // the whole string) but Figma has "E-Mail-Adresse:" bold + " z. B. name@beispiel.de"
        // regular — split on the first colon (both de/en copy follow the same "label: example"
        // shape) and render it as a styled overlay instead, hidden once a value is typed so it
        // behaves exactly like the real placeholder it's standing in for.
        const emailPlaceholder = t(`CheckoutPage:contactInformation:fieldPlaceholders.email`);
        const emailColonIndex = emailPlaceholder.indexOf(':');
        const emailPlaceholderBold = emailColonIndex >= 0 ? emailPlaceholder.slice(0, emailColonIndex + 1) : emailPlaceholder;
        const emailPlaceholderRegular = emailColonIndex >= 0 ? emailPlaceholder.slice(emailColonIndex + 1) : '';
        return (React.createElement("div", { className: styles.RegistrationForm },
            React.createElement("div", { className: styles.registrationWrapper },
                React.createElement(MaterialAutocomplete, { t: t, onChange: value => form.$('gender').onChange(this.changeValue(value)), label: t(form.$('gender').label), error: form.$('gender').hasError && form.$('gender').error, required: form.$('gender').value === '' ? true : false, className: styles.formControl, items: form.$('gender').extra.map((option) => ({
                        value: option.value,
                        label: t(`CheckoutPage:contactInformation:${option.label}`)
                    })), value: form.$('gender').value && form.$('gender').value.label ? form.$('gender').value.value : form.$('gender').value, 
                    // namespace={'CheckoutPage:contactInformation'}
                    size: 'custom', disableClearable: true }),
                React.createElement(MaterialField, { onChange: value => form.$('firstName').onChange(value, form.$('firstName').name), label: t(`CheckoutPage:contactInformation:fieldLabels.firstName`), placeholder: t(`CheckoutPage:contactInformation:fieldLabels.firstName`), floatingLabel: true, value: form.$('firstName').value, type: form.$('firstName').type, error: form.$('firstName').hasError && form.$('firstName').error, className: styles.firstName, size: 'custom', 
                    // Bug: without name/autoComplete, the browser has no structured hint to tell this
                    // field apart from lastName below (MdField renders both, but only when a caller
                    // passes them — see its own props) — confirmed live: Chrome's profile-autofill
                    // then can't disambiguate given-name vs family-name and fills the SAME value (the
                    // surname) into both, corrupting leads downstream (Odoo customer_firstname ==
                    // customer_lastname, traced to this modal). autocomplete="given-name" is the
                    // WHATWG-standard token that tells the browser exactly which name part this is.
                    name: form.$('firstName').name, autoComplete: 'given-name' }),
                React.createElement(MaterialField, { onChange: value => form.$('lastName').onChange(value, form.$('lastName').name), label: t(`CheckoutPage:contactInformation:fieldLabels.lastName`), placeholder: t(`CheckoutPage:contactInformation:fieldPlaceholders.lastName`), floatingLabel: true, value: form.$('lastName').value, type: form.$('lastName').type, error: form.$('lastName').hasError && form.$('lastName').error, className: styles.lastName, size: 'custom', name: form.$('lastName').name, autoComplete: 'family-name' }),
                React.createElement("div", { className: styles.emailFieldWrapper },
                    React.createElement(MaterialField, { onChange: value => form.$('email').onChange(value, form.$('email').name), 
                        // Not fieldLabels.email ("E-Mail Adresse", space) — the floated-label state
                        // should read "E-Mail-Adresse" (hyphen), matching the bold lead-in of the
                        // placeholder itself, so it's derived from the same emailPlaceholderBold string
                        // instead of a second, differently-worded translation key.
                        label: emailPlaceholderBold.replace(/:\s*$/, ''), 
                        // Single space, not '': invisible either way, but a non-empty placeholder keeps
                        // the input's :placeholder-shown pseudo-class meaningful (modals.styl uses it as
                        // an "is empty" hook to swap the overlay for the floated label) — an empty
                        // string placeholder never matches :placeholder-shown at all per spec.
                        placeholder: ' ', value: form.$('email').value, type: form.$('email').type, error: form.$('email').hasError && form.$('email').error, 
                        // helperText={form.$('email').showError ? form.$('email').error : ''}
                        className: styles.email, autoComplete: 'off', size: 'custom' }),
                    !form.$('email').value ? (React.createElement("span", { className: styles.emailPlaceholderOverlay, "aria-hidden": 'true' },
                        React.createElement("span", { className: styles.emailPlaceholderBold }, emailPlaceholderBold),
                        React.createElement("span", { className: styles.emailPlaceholderRegular }, emailPlaceholderRegular))) : null),
                React.createElement(MaterialAutocomplete, { onChange: value => form.$('phoneMain.countryCode').onChange(value), label: t(`CheckoutPage:contactInformation:fieldLabels.countryCode`), value: form.$('phoneMain.countryCode').value.value ? form.$('phoneMain.countryCode').value.value : form.$('phoneMain.countryCode').value, error: form.$('phoneMain.countryCode').hasError && form.$('phoneMain.countryCode').error, required: form.$('phoneMain.countryCode').value === '' ? true : false, className: styles.countryCode, classNameIcon: styles.countryCodeFormIcon, items: PHONE_PREFIXES, size: 'custom', disableClearable: true, listWithImage: 'true' }),
                React.createElement(MaterialField
                // type="tel" only picks the numeric keypad on mobile — it doesn't block letters
                // being typed (desktop keyboards, paste, …), and phone_areaCode only flags that
                // after the fact via the error text. Stripping non-digits here rejects them as
                // they're typed: MaterialField is a controlled input on form.$(...).value, so a
                // letter keystroke updates the field to the same digits-only value that was
                // already there and the letter never visually sticks.
                , { 
                    // type="tel" only picks the numeric keypad on mobile — it doesn't block letters
                    // being typed (desktop keyboards, paste, …), and phone_areaCode only flags that
                    // after the fact via the error text. Stripping non-digits here rejects them as
                    // they're typed: MaterialField is a controlled input on form.$(...).value, so a
                    // letter keystroke updates the field to the same digits-only value that was
                    // already there and the letter never visually sticks.
                    onChange: value => form.$('phoneMain.areaCode').onChange(value.replace(/\D/g, ''), form.$('phoneMain.areaCode').name), label: t(`CheckoutPage:contactInformation:fieldLabels.areaCode`), placeholder: t(`CheckoutPage:contactInformation:fieldPlaceholders.areaCode`), floatingLabel: true, value: form.$('phoneMain.areaCode').value, type: form.$('phoneMain.areaCode').type, error: form.$('phoneMain.areaCode').hasError && form.$('phoneMain.areaCode').error, className: styles.areaCode, size: 'custom' }),
                React.createElement(MaterialField
                // same digits-only fix as areaCode above.
                , { 
                    // same digits-only fix as areaCode above.
                    onChange: value => form.$('phoneMain.phoneNumber').onChange(value.replace(/\D/g, ''), form.$('phoneMain.phoneNumber').name), label: t(`CheckoutPage:contactInformation:fieldLabels.phoneNumber`), placeholder: t(`CheckoutPage:contactInformation:fieldPlaceholders.phoneNumber`), floatingLabel: true, value: form.$('phoneMain.phoneNumber').value, type: form.$('phoneMain.phoneNumber').type, error: form.$('phoneMain.phoneNumber').hasError && form.$('phoneMain.phoneNumber').error, className: styles.phoneNumber, size: 'custom' }),
                hasGoogleOptimize && React.createElement(TimePicker, { onHandleTimestampChange: this.onHandleTimestampChange, onDayChange: (value) => contactPageForm.$('day').onChange(value), onTimeChange: (value) => contactPageForm.$('time').onChange(value), day: day, time: time, className: styles.timePickerContainer, lang: lang, t: t }),
                React.createElement("div", { className: styles.checkedWrap },
                    React.createElement("span", { className: styles.topChecked },
                        React.createElement(Trans, { i18nKey: 'modals:offerRequest.termsConditions' },
                            React.createElement("a", { href: TERMS_AND_USE_URL, target: '_blank', className: styles.termsLink }, "Nutzungsbedingungen"))),
                    React.createElement(FormCheckbox, { className: styles.checkedRegister, errorClassName: styles.error, labelClassName: styles.agreementLabel, labelContentClassName: styles.agreementLabelContent, checkboxClassName: styles.agreementCheckbox, field: form.$('agreement'), label: this.renderAgreement() }))),
            !isSale ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { className: classnames(styles.confirm, styles.primaryCta), variant: 'filled', iconRight: 'chevron-right', onClick: this.onSubmit, disabled: isLoading }, isLoading ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } }) : t('CheckoutPage:requestOfferPrimaryCta')),
                React.createElement(Button, { className: classnames(styles.btnLink, styles.secondaryCta), variant: 'outlined', onClick: this.redirect }, t('CheckoutPage:onlineCheckoutModal.redirectBtn')))) : (React.createElement(Button, { className: classnames(styles.confirm, styles.btnSales), variant: 'filled', onClick: this.onSubmit, disabled: isLoading }, isLoading ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } }) : t('modals:financing.requestOfferSale'))),
            React.createElement("span", { className: classnames(styles.securityDescription, styles.securityDescriptionCta) },
                React.createElement(SvgClosedLockIcon, { className: classnames(styles.closedLockIcon, styles.closedLockIconCta) }),
                React.createElement("span", null, t('modals:offerRequest.securityDescription')))));
    }
};
RegistrationForm = __decorate([
    inject('appStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], RegistrationForm);
export default withGoogleOptimize(RegistrationForm);
